module.exports = __webpack_public_path__ + "img/chunxia.d968cf94.png";